import { FaFacebookF, FaInstagram, FaTiktok } from 'react-icons/fa6';

import { BrandColors } from 'constants/brand-colors';
import { Colors } from 'constants/ui';

import * as styled from '../styles/social-icon-row';

const PLATFORM_ICON: Record<LandingV2.SocialLink, React.ReactNode> = {
  facebook: <FaFacebookF size={20} color={Colors.white} />,
  instagram: <FaInstagram size={20} color={Colors.white} />,
  tiktok: <FaTiktok size={18} color={Colors.white} />,
};

const PLATFORM_BACKGROUND: Record<LandingV2.SocialLink, string> = {
  facebook: BrandColors.facebook,
  instagram: BrandColors.instagramGradient,
  tiktok: BrandColors.tiktok,
};

type Props = {
  platforms: LandingV2.SocialLink[];
};

export const SocialIconRow = ({ platforms }: Props) => (
  <styled.Row>
    {platforms.map((platform) => (
      <styled.IconCircle key={platform} $background={PLATFORM_BACKGROUND[platform]}>
        {PLATFORM_ICON[platform]}
      </styled.IconCircle>
    ))}
  </styled.Row>
);
